import { formulaBuilderTypes } from "../FormulaBuilder/Helpers/formulaHelpers"

const addressElementId = "address"
const checkboxElementId = "checkbox"
const dateElementId = "date"
const descriptionElementId = "description"
const dropdownElementId = "dropdown"
const emailElementId = "email"
const groupElementId = "group"
const headingElementId = "heading"
const matrixElementId = "matrix"
const matrixCheckboxElementId = "matrixcheckbox"
const numberElementId = "number"
const paragraphElementId = "paragraph"
const phoneElementId = "phone"
const radioElementId = "radio"
const textElementId = "textinput"
const timeElementId = "time"
const optionElementId = "option"

const basicElements = [
  {
    id: textElementId,
    label: "Short text",
    icon: "short_text",
    allowFormula: false,
    formulaType: formulaBuilderTypes.notEligible,
  },
  {
    id: paragraphElementId,
    label: "Long text",
    icon: "segment",
    allowFormula: false,
    formulaType: formulaBuilderTypes.notEligible,
  },
  {
    id: dropdownElementId,
    label: "Dropdown",
    icon: "arrow_drop_down_circle",
    includeInFormula: true,
    allowFormula: true,
    formulaType: formulaBuilderTypes.number,
  },
  {
    id: radioElementId,
    label: "Single choice",
    icon: "radio_button_checked",
    includeInFormula: true,
    allowFormula: true,
    formulaType: formulaBuilderTypes.number,
  },
  {
    id: checkboxElementId,
    label: "Multiple choice",
    icon: "check_box",
    includeInFormula: true,
    allowFormula: true,
    formulaType: formulaBuilderTypes.number,
  },
  {
    id: numberElementId,
    label: "Number",
    icon: "numbers",
    includeInFormula: true,
    allowFormula: true,
    formulaType: formulaBuilderTypes.number,
  },
  {
    id: dateElementId,
    label: "Date",
    icon: "calendar_month",
    isDateType: true,
    includeInFormula: true,
    allowFormula: true,
    formulaType: formulaBuilderTypes.date,
  },
  {
    id: timeElementId,
    label: "Time",
    icon: "schedule",
    isDateType: true,
    includeInFormula: true,
    allowFormula: true,
    formulaType: formulaBuilderTypes.time,
  },
]

const specialElements = [
  {
    id: groupElementId,
    label: "Section",
    tooltip: "A collapsible grouping of elements",
    icon: "menu_open",
    includeInFormula: true,
    allowFormula: true,
    formulaType: formulaBuilderTypes.number,
  },
  {
    id: headingElementId,
    label: "Heading",
    tooltip: "A heading element",
    icon: "title",
    allowFormula: false,
    formulaType: formulaBuilderTypes.undefined,
  },
  {
    id: descriptionElementId,
    label: "Description",
    tooltip: "A description block",
    icon: "description",
    allowFormula: false,
    formulaType: formulaBuilderTypes.undefined,
  },
  {
    id: emailElementId,
    label: "E-mail",
    icon: "alternate_email",
    allowFormula: false,
    formulaType: formulaBuilderTypes.undefined,
  },
  {
    id: addressElementId,
    label: "Address",
    icon: "location_on",
    allowFormula: false,
    formulaType: formulaBuilderTypes.undefined,
  },
  {
    id: phoneElementId,
    label: "Phone",
    icon: "call",
    allowFormula: false,
    formulaType: formulaBuilderTypes.undefined,
  },
  {
    id: matrixElementId,
    label: "Matrix",
    tooltip: "A collapsible grouping of elements",
    icon: "table",
    includeInFormula: true,
    allowFormula: true,
    formulaType: formulaBuilderTypes.undefined,
  },
]

const hiddenTypes = [
  {
    id: matrixCheckboxElementId,
    label: "Matrix",
    tooltip: "A collapsible grouping of elements",
    icon: "table",
    includeInFormula: true,
    allowFormula: true,
    formulaType: formulaBuilderTypes.undefined,
  },
  {
    id: optionElementId,
    label: "Option",
    icon: "check_box",
  },
]

const elementTypes = {
  addressElementId: addressElementId,
  checkboxElementId: checkboxElementId,
  dateElementId: dateElementId,
  dropdownElementId: dropdownElementId,
  emailElementId: emailElementId,
  groupElementId: groupElementId,
  headingElementId: headingElementId,
  descriptionElementId: descriptionElementId,
  matrixElementId: matrixElementId,
  matrixCheckboxElementId: matrixCheckboxElementId,
  numberElementId: numberElementId,
  paragraphElementId: paragraphElementId,
  phoneElementId: phoneElementId,
  radioElementId: radioElementId,
  textElementId: textElementId,
  timeElementId: timeElementId,
  optionElementId: optionElementId,
  basicElements,
  specialElements,
  hiddenTypes,
  findTypeProfile: (typeId) => {
    const typeProfile = [
      ...basicElements,
      ...specialElements,
      ...hiddenTypes,
    ].find((type) => type.id === typeId)

    return typeProfile
  },
  isMatrixType: (type) => {
    return [matrixCheckboxElementId, matrixElementId].includes(type)
  },
  isMultiAnswerType: (type) => {
    return [checkboxElementId, matrixCheckboxElementId].includes(type)
  },
  propertiesConfig: {
    hasHelperText: [
      addressElementId,
      checkboxElementId,
      dateElementId,
      dropdownElementId,
      emailElementId,
      groupElementId,
      headingElementId,
      matrixElementId,
      matrixCheckboxElementId,
      numberElementId,
      paragraphElementId,
      phoneElementId,
      radioElementId,
      textElementId,
      timeElementId,
    ],
    hasWidth: [
      textElementId,
      paragraphElementId,
      dropdownElementId,
      radioElementId,
      checkboxElementId,
      numberElementId,
      dateElementId,
      timeElementId,
      emailElementId,
      addressElementId,
      phoneElementId,
      headingElementId,
      descriptionElementId,
    ],
    hasHeight: [paragraphElementId, headingElementId, descriptionElementId],
    hasDefault: [
      dropdownElementId,
      radioElementId,
      checkboxElementId,
      dateElementId,
      timeElementId,
    ],
    hasOptions: [
      dropdownElementId,
      radioElementId,
      checkboxElementId,
      matrixElementId,
      matrixCheckboxElementId,
    ],
    hasQuestionLabels: [matrixElementId, matrixCheckboxElementId],
    hasMinValue: [numberElementId, dateElementId, timeElementId],
    hasMaxValue: [numberElementId, dateElementId, timeElementId],
    hasSize: [headingElementId, descriptionElementId],
    hasAlignment: [
      headingElementId,
      descriptionElementId,
      radioElementId,
      checkboxElementId,
    ],
    conditionalDisplayAlwaysOn: [
      descriptionElementId,
      groupElementId,
      headingElementId,
    ],
    hasRequiredIndicator: [
      addressElementId,
      checkboxElementId,
      dateElementId,
      dropdownElementId,
      emailElementId,
      numberElementId,
      paragraphElementId,
      phoneElementId,
      radioElementId,
      textElementId,
      timeElementId,
    ],
  },
}

export default elementTypes
